import React, { useState, useEffect } from 'react'
import { Alert, Button, Card, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import { useFormik } from 'formik'
import ConfigLayout from '../../Layouts/ConfigLayout'
import { EmailSchema } from '../../../utils/validation'
import { forgotPasswordUser } from '../../../redux/actions/user'
import { useSelector, useDispatch } from 'react-redux'

const ForgotPassword = () => {
  const [alertState, setAlertState] = useState({ show: false, variant: 'info', message: '' })
  const dispatch = useDispatch()

  const { forgotPasswordState } = useSelector((state) => ({
    forgotPasswordState: state.user.forgotPassword
  }))

  useEffect(() => {
    if (forgotPasswordState.error !== false) {
      setAlertState({
        show: true,
        variant: 'danger',
        message: 'Unable to send reset password email'
      })
    }

    if (forgotPasswordState.success) {
      setAlertState({
        show: true,
        variant: 'success',
        message: 'Please check your email for a reset password link'
      })
    }

    if(window.location.search.substr(1)) {
      setAlertState({
        show: true,
        variant: 'info',
        message: 'Change password link has expired. Please generate a new link'
      })
    }
  }, [forgotPasswordState.error, forgotPasswordState.success])

  const forgotPassword = useFormik({
    initialValues: {
      email: ''
    },
    enableReinitialize: true,
    validationSchema: EmailSchema,
    onSubmit: (values) => {
      dispatch(forgotPasswordUser(values))
    }
  })

  return (
    <ConfigLayout showUser={false}>
      <Container fluid id='login'>
        <Row>
          <Col xs={12} className='mb-3'>
            <Card className='auth-container mx-auto'>
              <Card.Body>
                <Form onSubmit={forgotPassword.handleSubmit} noValidate>
                  <Row>
                    <Col xs={12}>
                      <h3>Log In / Forgot Password</h3>
                      <Alert 
                        show={alertState.show} 
                        dismissible
                        variant={alertState.variant}
                        onClose={() => setAlertState((ps) => ({ ...ps, show: false }))}
                      >
                        {alertState.message}
                      </Alert>
                    </Col>
                  </Row>
                  <p className='font-85'>
                    If you have forgotten your password, you can reset it. Please enter your email below and well email you a reset link.
                  </p>
                  <Row>
                    <Form.Group as={Col} xs={6} className='mb-3'>
                      <Form.Label>Enter Email</Form.Label>
                      <Form.Control
                        id='email'
                        name='email'
                        type='email'
                        onChange={forgotPassword.handleChange}
                        onBlur={forgotPassword.handleBlur}
                        isInvalid={!!forgotPassword.errors.email && forgotPassword.touched.email}
                        value={forgotPassword.values.email}
                        autoComplete='email'
                      />
                      <Form.Control.Feedback type='invalid'>
                        {forgotPassword.errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Col xs={4} className='mb-3'>
                      <Button
                        type='submit'
                        className='w-100'
                        disabled={forgotPasswordState.loading}
                        style={{ marginTop: '25px' }}
                      >
                        {
                          forgotPasswordState.loading
                            ? (
                              <Spinner animation='border' role='status' size='sm' />
                            )
                            : 'Reset Password'
                        }
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} className='text-center mb-3'>
            <h4>
              <u><a className='text-muted' href='https://info.pocp.com/lupus_advisor' target='_blank' rel='noreferrer'>About Lupus Advisor</a></u>
            </h4>
          </Col>
          <Col xs={12} className='text-center'>
            <div className='text-muted'>
              Lupus Advisor Configurator is available to current customers of Lupus Advisor.
            </div>
          </Col>
        </Row>
      </Container>
    </ConfigLayout>
  )
}

export default ForgotPassword
